// extracted by mini-css-extract-plugin
export default {"form":"guide_form__ny+iw","addMore":"guide_addMore__ZaMoY"};